import { Button, styled as muiStyled } from '@mui/material';

export const ReprocessButton = muiStyled(Button)({
  padding: '8px 16px',
});
